'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".XCircle-module_container__dh6RE{height:auto;vertical-align:middle;width:3rem;fill:#000}";
var styles = {"container":"XCircle-module_container__dh6RE"};
styleInject["default"](css_248z, 'd84e6dff-4a5d-4342-9d20-229d5c6925e2');

exports["default"] = styles;
